import { useNavigate } from "react-router-dom";
import { useSharedState } from "state";
import {
  IconBook,
  IconBooks,
  IconClipboardList,
  IconClipboardText,
  IconContract,
  IconFile,
  IconFiles,
  IconLayoutKanban,
  IconLogout,
  IconLogout2,
  IconMoon,
  IconPasswordUser,
  IconReceipt,
  IconReport,
  IconSettings,
  IconSun,
  IconTemplate,
  IconUser,
  IconUsers,
} from "@tabler/icons-react";
import ChangePassword from "components/auth/change-password";
import DangerModal from "components/modal/danger";
import LogoTitle from "assets/img/dock_title.png";

export default function VerticalNavbar() {
  const { darkMode, setDarkMode, user, logout, isAdmin, sidebarCounters } = useSharedState();

  const navigate = useNavigate();

  const isActive = (pathname: string): string => {
    const currentPathname = window.location.pathname;
    const currentSearch = window.location.search;

    // Handle query parameters
    if (pathname.includes("?")) {
      const [targetPath, targetQuery] = pathname.split("?");
      return currentPathname === targetPath && currentSearch.includes(targetQuery) ? "active" : "";
    }

    // Handle existing type=other logic
    if (currentSearch.includes("type=other")) {
      return pathname.includes("type=other") ? "active" : "";
    }

    // Exact match for pathname without query parameters
    return currentPathname === pathname && !currentSearch ? "active" : "";
  };

  const countByLocation = (locationId: number, type: "document" | "payment") => {
    let count = 0;
    sidebarCounters?.locations_counts.forEach((location) => {
      if (location.location_id === locationId) {
        count = type === "document" ? location.document_approval_count : location.payment_approval_count;
      }
    });
    return count;
  };

  const changeTheme = () => {
    if (darkMode) {
      localStorage.setItem("tablerTheme", "light");
      setDarkMode(false);
    } else {
      localStorage.setItem("tablerTheme", "dark");
      setDarkMode(true);
    }
  };

  return (
    <>
      <aside className="navbar navbar-vertical navbar-expand-lg">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#sidebar-menu"
            aria-controls="sidebar-menu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {/* <h1 className="navbar-brand navbar-brand-autodark">
            <img src={LogoTitle} height="36" alt="" />
          </h1> */}
          <div className="self-center lg:mb-4 w-[74px]">
            <img className="object-contain" src={LogoTitle} />
          </div>
          <div className="w-8"></div>
          {/* <div className="navbar-nav flex-row d-lg-none">
            <div className="d-flex">
              <div onClick={changeTheme} className="nav-link px-0 hide-theme-dark">
                <IconMoon />
              </div>
              <div onClick={changeTheme} className="nav-link px-0 hide-theme-light">
                <IconSun />
              </div>
            </div>
          </div> */}
          <div className="collapse navbar-collapse" id="sidebar-menu">
            <ul className="navbar-nav">
              <li className={`nav-item dropdown ${isActive("/tasks")}`}>
                <div
                  className="nav-link dropdown-toggle show"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                  role="button"
                  aria-expanded="true"
                >
                  <span className="nav-link-icon d-lg-inline-block">
                    <IconLayoutKanban />
                  </span>
                  <span className="nav-link-title">Задачи</span>
                </div>
                <div className="dropdown-menu show">
                  <div className="dropdown-menu-columns">
                    <div className="dropdown-menu-column">
                      <div className={`dropdown-item ${isActive("/tasks")}`} onClick={() => navigate("/tasks")}>
                        <span className="nav-link-icon d-lg-inline-block">
                          <IconUser />
                        </span>
                        <span className="nav-link-title">Мои задачи</span>
                        <span className="badge badge-sm bg-primary-lt text-uppercase ms-auto">
                          {sidebarCounters?.task_approval_for_me || 0}
                        </span>
                      </div>

                      <div
                        className={`dropdown-item ${isActive("/tasks?type=other")}`}
                        onClick={() => navigate("/tasks?type=other")}
                      >
                        <span className="nav-link-icon d-lg-inline-block">
                          <IconUsers />
                        </span>
                        <span className="nav-link-title">Другие задачи</span>
                        <span className="badge badge-sm bg-primary-lt text-uppercase ms-auto">
                          {sidebarCounters?.task_approval_for_others || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              {user.result.document_approval_access && (
                <li className={`nav-item dropdown ${isActive("/documents")}`}>
                  <div
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="false"
                    role="button"
                    aria-expanded="true"
                  >
                    <span className="nav-link-icon d-lg-inline-block">
                      <IconFile />
                    </span>
                    <span className="nav-link-title">Договоры</span>
                  </div>
                  <div className="dropdown-menu">
                    <div className="dropdown-menu-columns">
                      <div className="dropdown-menu-column">
                        {user.locations.map((location) => (
                          <div
                            key={location.location_id}
                            className={`dropdown-item ${isActive(
                              `/documents/${encodeURIComponent(location.location)}`
                            )}`}
                            onClick={() => navigate(`/documents/${encodeURIComponent(location.location)}`)}
                          >
                            <span className="nav-link-icon d-lg-inline-block">
                              <IconFile />
                            </span>
                            <span className="nav-link-title">{location.location}</span>
                            <span className="badge badge-sm bg-primary-lt text-uppercase ms-auto">
                              {countByLocation(location.location_id, "document")}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>
              )}

              {user.result.payment_approval_access && (
                <li className={`nav-item dropdown ${isActive("/payments")}`}>
                  <div
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="false"
                    role="button"
                    aria-expanded="true"
                  >
                    <span className="nav-link-icon d-lg-inline-block">
                      <IconReceipt />
                    </span>
                    <span className="nav-link-title">Оплаты</span>
                  </div>
                  <div className="dropdown-menu">
                    <div className="dropdown-menu-columns">
                      <div className="dropdown-menu-column">
                        {user.locations.map((location) => (
                          <div
                            key={location.location_id}
                            className={`dropdown-item ${isActive(
                              `/payments/${encodeURIComponent(location.location)}`
                            )}`}
                            onClick={() => navigate(`/payments/${encodeURIComponent(location.location)}`)}
                          >
                            <span className="nav-link-icon d-lg-inline-block">
                              <IconReceipt />
                            </span>
                            <span className="nav-link-title">{location.location}</span>
                            <span className="badge badge-sm bg-primary-lt text-uppercase ms-auto">
                              {countByLocation(location.location_id, "payment")}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </li>
              )}

              {user.result.budget_access && (
                <li
                  className={`nav-item dropdown ${
                    isActive("/budgets") || isActive("/reports") || isActive("/summary")
                  }`}
                >
                  <div
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="false"
                    role="button"
                    aria-expanded="true"
                  >
                    <span className="nav-link-icon d-lg-inline-block">
                      <IconClipboardText />
                    </span>
                    <span className="nav-link-title">Бюджеты</span>
                  </div>
                  <div className="dropdown-menu">
                    <div className="dropdown-menu-columns">
                      <div className="dropdown-menu-column">
                        {user.locations.map((location) => (
                          <div
                            key={location.location_id}
                            className={`dropdown-item ${isActive(`/budgets/${encodeURIComponent(location.location)}`)}`}
                            onClick={() => navigate(`/budgets/${encodeURIComponent(location.location)}`)}
                          >
                            <span className="nav-link-icon d-lg-inline-block">
                              <IconClipboardList />
                            </span>
                            <span className="nav-link-title">{location.location}</span>
                          </div>
                        ))}

                        <div className={`dropdown-item ${isActive("/reports")}`} onClick={() => navigate("/reports")}>
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconClipboardList />
                          </span>
                          <span className="nav-link-title">Отчёты</span>
                        </div>

                        <div className={`dropdown-item ${isActive("/summary")}`} onClick={() => navigate("/summary")}>
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconClipboardList />
                          </span>
                          <span className="nav-link-title">Сводная таблица</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              )}

              <li className={`nav-item dropdown ${isActive("/contractors")}`} onClick={() => navigate("/contractors")}>
                <div className="nav-link">
                  <span className="nav-link-icon d-lg-inline-block">
                    <IconContract />
                  </span>
                  <span className="nav-link-title">Контрагенты</span>
                </div>
              </li>

              {isAdmin && (
                <li className="nav-item dropdown">
                  <div
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="false"
                    role="button"
                    aria-expanded="true"
                  >
                    <span className="nav-link-icon d-lg-inline-block">
                      <IconBook />
                    </span>
                    <span className="nav-link-title">Справочники</span>
                  </div>
                  <div className="dropdown-menu">
                    <div className="dropdown-menu-columns">
                      <div className="dropdown-menu-column">
                        <div className={`dropdown-item ${isActive("/users")}`} onClick={() => navigate("/users")}>
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconUsers />
                          </span>
                          <span className="nav-link-title">Пользователи</span>
                        </div>

                        <div
                          className={`dropdown-item ${isActive("/templates")}`}
                          onClick={() => navigate("/templates")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate />
                          </span>
                          <span className="nav-link-title">Шаблоны</span>
                        </div>

                        <div className={`dropdown-item ${isActive("/levels")}`} onClick={() => navigate("/levels")}>
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate />
                          </span>
                          <span className="nav-link-title">Уровни</span>
                        </div>

                        <div className={`dropdown-item ${isActive("/codes")}`} onClick={() => navigate("/codes")}>
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate />
                          </span>
                          <span className="nav-link-title">Коды ИТ</span>
                        </div>

                        <div className={`dropdown-item ${isActive("/formulas")}`} onClick={() => navigate("/formulas")}>
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate />
                          </span>
                          <span className="nav-link-title">Формулы</span>
                        </div>

                        <div
                          className={`dropdown-item ${isActive("/constructor")}`}
                          onClick={() => navigate("/constructor")}
                        >
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconTemplate />
                          </span>
                          <span className="nav-link-title">Конструктор</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              )}

              <li className="nav-item dropdown">
                <div
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                  role="button"
                  aria-expanded="true"
                >
                  <span className="nav-link-icon d-lg-inline-block">
                    <IconSettings />
                  </span>
                  <span className="nav-link-title">Настройки</span>
                </div>
                <div className="dropdown-menu">
                  <div className="dropdown-menu-columns">
                    <div className="dropdown-menu-column">
                      <div className="dropdown-item" data-bs-toggle="modal" data-bs-target="#modal-password">
                        <span className="nav-link-icon d-lg-inline-block">
                          <IconPasswordUser />
                        </span>
                        <span className="nav-link-title">Сменить пароль</span>
                      </div>

                      {/* <div className="dropdown-item d-except-lg" onClick={changeTheme}>
                        <span className="nav-link-icon d-lg-inline-block px-0 hide-theme-dark">
                          <IconMoon />
                        </span>
                        <span className="nav-link-icon d-lg-inline-block px-0 hide-theme-light">
                          <IconSun />
                        </span>
                        <span className="nav-link-title">Сменить тему</span>
                      </div> */}

                      {window.innerWidth < 1024 && (
                        <div className="dropdown-item" data-bs-toggle="modal" data-bs-target="#modal-logout">
                          <span className="nav-link-icon d-lg-inline-block">
                            <IconLogout className="text-[#EF4343] cursor-pointer" />
                          </span>
                          <span className="nav-link-title text-danger">Выйти из системы</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </aside>

      <ChangePassword />
      <DangerModal
        modal_id="modal-logout"
        dangerDescription="Вы действительно хотите выйти из учётной записи?"
        cancel={() => undefined}
        confirm={logout}
      />
    </>
  );
}
